import { useQuery } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import { type DictionaryEntryDto } from '@/api/generated/models/dictionary-entry-dto';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { type RefetchModel } from '@/api/model/Refetch.model.ts';
import { useApiClient } from '@/api/util/useApiClient.util';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Response = DictionaryEntryDto[];

interface Return {
  dictionaries: Response;
  getAllDictionaries: RefetchModel<Response>;
  isFetchingDictionariesTypes: boolean;
}

export const useGetAllDictionaries = (): Return => {
  const { dictionariesV2Api } = useApiClient();
  const {
    user: { dataReady },
  } = useUserContext();

  const { data, isLoading, refetch } = useQuery<Response, AxiosError>({
    enabled: dataReady,
    queryFn: async () => {
      const response = await dictionariesV2Api.getDictionaries();
      return response?.data;
    },
    queryKey: [QueryKeyEnum.DICTIONARIES.ALL],
  });

  return {
    dictionaries: data ?? [],
    getAllDictionaries: refetch,
    isFetchingDictionariesTypes: isLoading,
  };
};
